import { useMemo } from 'react';

import { useGetTotalAssets } from './useGetTotalAssets';

import { useModal } from '@/features/Modals';

export const useGetPoolUtilisation = () => {
    const { modalProps } = useModal();

    const { totalBorrowed } = modalProps || {};

    const { asset } = useGetTotalAssets();

    return useMemo(() => {
        if (Number(asset) === 0) {
            return '0.00';
        }

        return Math.min((Number(totalBorrowed) / Number(asset)) * 100, 100).toFixed(2);
    }, [asset, totalBorrowed]);
};
